import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { KycStatusInterface } from '../../models/dashboard/dashboard/kyc-status';

interface IInitialState {
  kycStatusData?: KycStatusInterface;
  showKycBanner: boolean;
  isKycStatusLoaded: boolean;
}

const initialState: IInitialState = {
  kycStatusData: undefined,
  showKycBanner: true,
  isKycStatusLoaded: false,
};

const kycStatusSlice = createSlice({
  name: 'kycStatusSlice',
  initialState,
  reducers: {
    setKycStatusData(state, action: PayloadAction<KycStatusInterface>) {
      state.kycStatusData = action.payload;
      state.isKycStatusLoaded = true;
    },
    setShowKycBanner(state, action: PayloadAction<boolean>) {
      state.showKycBanner = action.payload;
    },
  },
});

export const kycStatusDataActions = kycStatusSlice.actions;
export default kycStatusSlice.reducer;
